import React, { Fragment, useEffect, useContext } from "react";
import { useCookies } from "react-cookie";
import { CartContext } from "../../context/cartContext";
import { useOAT } from "context/OATContext";

const LoadCart = (props) => {
  const ClientCart = useContext(CartContext);
  const { isOAT } = useOAT();
  const [cookies] = useCookies(["gwLoginData"]);

  useEffect(() => {
    props.setIsCartLoaded(true);
    if (cookies.gwLoginData && !isOAT) {
      syncCart();
    }
  }, []);

  const syncCart = async () => {
    await ClientCart.myCart();
  };

  return <Fragment>{props.children}</Fragment>;
};

export default LoadCart;
